module.exports = __webpack_public_path__ + "static/media/courts-secondary.10d2083b.jpg";